"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pushbutton_1 = __importDefault(require("../../style/shared/pushbutton"));
exports.default = theme => {
    const sharedStyles = pushbutton_1.default(theme);
    return {
        root: {
            ...sharedStyles.root,
            '&[disabled]': {
                color: theme.disabled.grey3,
                '&[data-is-primary="true"]': {
                    color: theme.white1,
                    borderColor: theme.disabled.indigo3,
                    backgroundColor: theme.disabled.indigo3
                },
                '&[data-is-secondary="true"]': {
                    color: theme.disabled.indigo3
                },
                '&[data-is-warning="true"]': {
                    color: theme.disabled.warningRed,
                    borderColor: theme.disabled.warningRed
                },
                '&[data-is-complete=true]': {
                    backgroundColor: theme.disabled.indigo3,
                    color: theme.white1
                }
            },
            '&[data-is-sexy-shadow="true"]': {
                background: theme.white1,
                height: 40,
                boxShadow: theme.indigoShadow2,
                border: 'none',
                padding: '0 20px',
                '&:not([disabled]):hover': {
                    backgroundColor: theme.indigo2
                },
                '&:not([disabled]):hover span': {
                    color: theme.white1
                },
                '& span': {
                    textTransform: 'inherit',
                    color: theme.grey1,
                    fontWeight: 600,
                    fontSize: 14
                }
            },
            '&[data-is-complete=true]': {
                backgroundColor: theme.indigo3,
                color: theme.white1
            }
        },
        prefix: {
            ...sharedStyles.prefix
        },
        suffix: {
            ...sharedStyles.suffix
        },
        text: {
            ...sharedStyles.text,
            '[aria-haspopup="true"] > &::after': {
                content: '"…"'
            }
        }
    };
};
//# sourceMappingURL=pushbutton.style.js.map